import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'tiny-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: '',
    token: '',
    addclientpicker: false,
    tutorapplypicker: false,
    showvideospicker: false,
    showoptimizationpicker: false,
    showfollowpicker: false,
    showconsultantspicker: false,
    showtmap: false,
    showhousealbum: false,
    showcommonarticleedit: false,
    citylist:[],
  },
  mutations: {
    setuser(state, value) {
      cookie.set('user', JSON.stringify(value));
      state.user = value;
    },
    settoken(state, value){
      cookie.set('token', value);
      state.token = value;
    },
    setaddclientpicker(state, value) {
      state.addclientpicker = value;
    },
    settutorapplypicker(state, value) {
      state.tutorapplypicker = value;
    },
    setshowvideospicker(state, value){
      state.showvideospicker = value;
    },
    setshowoptimizationpicker(state, value){
      state.showoptimizationpicker = value;
    },
    setshowfollowpicker(state, value){
      state.showfollowpicker = value;
    },
    setshowconsultantspicker(state, value){
      state.showconsultantspicker = value;
    },
    setshowtmap(state, value) {
      state.showtmap = value;
    },
    setshowhousealbum(state, value) {
      state.showhousealbum = value;
    },
    setshowcommonarticleedit(state, value) {
      state.showcommonarticleedit = value;
    },
    setcitylist(state,value){
      state.citylist = value;
    }
  },
  actions: {

  },
  getters: {
    gettoken: (state)=>{
      return state.token || cookie.get('token');
    },
    getuser: (state)=>{
      var val = cookie.get('user');
      if (val) val = JSON.parse(val);
      return state.user || val;
    },
    getaddclientpicker: (state)=>{
      return state.addclientpicker;
    },
    gettutorapplypicker: (state)=>{
      return state.tutorapplypicker;
    },
    getshowvideospicker: (state)=>{
      return state.showvideospicker;
    },
    getshowoptimizationpicker: (state)=>{
      return state.showoptimizationpicker;
    },
    getshowfollowpicker: (state)=>{
      return state.showfollowpicker;
    },
    getshowconsultantspicker: (state)=>{
      return state.showconsultantspicker;
    },
    getshowtmap: (state)=>{
      return state.showtmap;
    },
    getshowhousealbum: (state)=>{
      return state.showhousealbum;
    },
    getshowcommonarticleedit: (state)=>{
      return state.showcommonarticleedit;
    },
    getcitylist: (state)=>{
      return state.citylist;
    }
  },
})